'use strict';
import { FeedbackFormBase } from './FeedbackFormBase';
import Render  from './FeedbackFormRender';
import { connect } from 'react-redux';

class FeedbackForm extends FeedbackFormBase {
    render() {
        return Render.call(this, this.props, this.state);
    }
}

export default FeedbackForm = connect((state)=>{
    return {user:state.user || {}}
})(FeedbackForm);
